/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';

const Input = ({ selectedValue, handleChange }) => {
  return (
    <div style={{ display: 'flex', gap: 40 }}>
      <label>
        <input type="radio" value="yes" checked={selectedValue === 'yes'} onChange={handleChange} />
        Yes
      </label>
      <label>
        <input type="radio" value="no" checked={selectedValue === 'no'} onChange={handleChange} />
        No
      </label>
    </div>
  );
};

export default Input;
